import React from "react";
import PropTypes from "prop-types";

import ActionLogger from "action-logger";
import PDPImageryThumbnails from "./pdp-imagery-thumbnails";
import PDPFeaturedImage from "./pdp-featured-image";
import ProductImageRotation from "../../../helpers/product-image-rotation";
import MaternityHelper from "helpers/maternity-helper";
import { getProductImageUrlsByOrientation } from "../../../helpers/product-image-helpers";
import { productPropType } from "../../propTypes";

export class PDPImagery extends React.Component {
  static propTypes = {
    isCloudZoomEnabled: PropTypes.bool.isRequired,
    isProductDrawer: PropTypes.bool,
    product: productPropType,
    reviews: PropTypes.object,
    reviewsCoverPhotos: PropTypes.array,
    userData: PropTypes.object,
    workingFilters: PropTypes.object,
  };

  componentDidUpdate(oldProps) {
    if (this.props.workingFilters !== oldProps.workingFilters) {
      // Updating the displayed image when the workingFilters are updated. Onload,
      // it seems like the workingFilters are not present.
      this.setState({
        displayedImageKey: Object.keys(this.getFilteredImages() || {})[0],
      });
    }
  }

  // ACQ-719 - using canonical sizes from our working filters to display
  // plus or missy images first on the PDP
  getProductImageRotation = () => {
    const { product, userData } = this.props;
    const sizeFilters = this.props.workingFilters?.canonicalSizes || [];
    const showMaternityBumpImage = MaternityHelper.showMaternityBumpImage(userData);
    const imageRotation = ProductImageRotation(sizeFilters, product, showMaternityBumpImage);
    return imageRotation;
  };

  getFilteredImages = () => {
    const { product } = this.props;
    const filteredImages = {};
    for (const orientation of this.getProductImageRotation()) {
      const image = product?.images?.[orientation];
      if (image) filteredImages[orientation] = image;
    }
    return filteredImages;
  };

  handleClickThumbnail = orientation => {
    this.setState({
      displayedImageKey: orientation,
    });

    ActionLogger.logAction({
      action: "click_altimages",
      index: this.getProductImageRotation().indexOf(orientation),
      objectType: "node",
      style_name: this.props.product.id,
    });
  };

  state = {
    displayedImageKey: Object.keys(this.getFilteredImages() || {})[0],
  };

  render() {
    const { isCloudZoomEnabled, product, reviewsCoverPhotos, reviews } = this.props;
    const { displayedImageKey, displayedThumbIndex } = this.state;

    return (
      <div className="pdp-left">
        <div className="product-images">
          <PDPImageryThumbnails
            reviews={reviews}
            reviewsCoverPhotos={reviewsCoverPhotos}
            displayedThumbIndex={displayedThumbIndex}
            filteredImages={this.getFilteredImages()}
            isProductDrawer={this.props.isProductDrawer}
            onClickThumbnail={this.handleClickThumbnail}
            product={product}
          />
          <div className="featured-image-wrapper">
            <div className="featured-image-wrapper__center">
              <PDPFeaturedImage
                imageGroup={getProductImageUrlsByOrientation(product?.images, [displayedImageKey])}
                product={product}
                isCloudZoomEnabled={isCloudZoomEnabled}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PDPImagery;
